import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dbus' },
  { path: '/dbus', name: 'Dbus', component: () => import('@/pages/dbus/index.vue') },
  { path: '/order', name: 'Order', component: () => import('@/pages/order/index.vue') },
  { path: '/ordering', name: 'Ordering', component: () => import('@/pages/ordering/index.vue') },
  { path: '/orderList', name: 'OrderList', component: () => import('@/pages/orderList/index.vue') },
  { path: '/orderComplete', name: 'OrderComplete', component: () => import('@/pages/orderComplete/index.vue') },
  { path: '/orderMap', name: 'OrderMap', component: () => import('@/pages/orderMap/index.vue') },
  { path: '/userCenter', name: 'UserCenter', component: () => import('@/pages/userCenter/index.vue') },
  { path: '/login', name: 'Login', component: () => import('@/pages/login/index.vue') },
  { path: '/cityAll', name: 'CityAll', component: () => import('@/pages/cityAll/index.vue') },
  { path: '/searchAddress', name: 'SearchAddress', component: () => import('@/pages/searchAddress/index.vue') },
  { path: '/searchAddressq', name: 'SearchAddressq', component: () => import('@/pages/searchAddressq/index.vue') },
  { path: '/searchMap', name: 'SearchMap', component: () => import('@/pages/searchMap/index.vue') },
  { path: '/trip', name: 'Trip', component: () => import('@/pages/trip/index.vue') },
  { path: '/pages/trip/index', redirect: '/trip' },
  { path: '/tripDetail', name: 'TripDetail', component: () => import('@/pages/tripDetail/index.vue') },
  { path: '/pages/tripDetail/tripDetail', redirect: '/tripDetail' },
  { path: '/cancelOrder', name: 'CancelOrder', component: () => import('@/pages/cancelOrder/index.vue') },
  { path: '/cancelOrderDetail', name: 'CancelOrderDetail', component: () => import('@/pages/cancelOrderDetail/index.vue') },
  { path: '/ticket', name: 'Ticket', component: () => import('@/pages/ticket/index.vue') },
  { path: '/pages/ticket/index', redirect: '/ticket' },
  { path: '/ticketDetail', name: 'TicketDetail', component: () => import('@/pages/ticketDetail/index.vue') },
  { path: '/checkTicket', name: 'CheckTicket', component: () => import('@/pages/checkTicket/index.vue') },
  { path: '/comment', name: 'Comment', component: () => import('@/pages/comment/index.vue') },
  { path: '/feedback', name: 'Feedback', component: () => import('@/pages/feedback/index.vue') },
  { path: '/feedbackList', name: 'FeedbackList', component: () => import('@/pages/feedbackList/index.vue') },
  { path: '/feedbackDetail', name: 'FeedbackDetail', component: () => import('@/pages/feedbackDetail/index.vue') },
  { path: '/about', name: 'About', component: () => import('@/pages/about/index.vue') },
  { path: '/web', name: 'Web', component: () => import('@/pages/web/index.vue') },
  { path: '/pincheRule', name: 'PincheRule', component: () => import('@/pages/pincheRule/index.vue') },
  { path: '/zhuancheRule', name: 'ZhuancheRule', component: () => import('@/pages/zhuancheRule/index.vue') },
  { path: '/stationDetail', name: 'StationDetail', component: () => import('@/pages/stationDetail/index.vue') },
  { path: '/newIndex', name: 'NewIndex', component: () => import('@/pages/newIndex/index.vue') },
  { path: '/vehicleTrainDiagram', name: 'VehicleTrainDiagram', component: () => import('@/pages/vehicleTrainDiagram/index.vue') },
  { path: '/wdSearch', name: 'WdSearch', component: () => import('@/pages/wdSearch/index.vue') }
]

export default new VueRouter({ mode: 'hash', routes })
